export default "__VITE_ASSET__vrle$QaO__"